import { BillingProduct } from '@src/types'
import { useActiveSubscriptions } from './useActiveSubscriptions'

export const STANDALONE_VIDEO_CALL_PRODUCTS = [
  BillingProduct.FreeSoftwareOnlyVideoCallsAnnualMembership,
]

export const useHasStandaloneVideoCallSubscription = () => {
  const subscriptions = useActiveSubscriptions()

  return subscriptions.some((subscription) =>
    STANDALONE_VIDEO_CALL_PRODUCTS.includes(subscription.primaryProduct.key as BillingProduct),
  )
}
